import React from "react";
import Body from "../components/Body";
import Player from "../widgets/Player";
import TabBar from "../widgets/TabBar";

const Video = () => {
  const [selectedTab, setSelectedTab] = React.useState("outdoor");
  const tabs = [
    { label: "Outdoor", value: "outdoor" },
    { label: "Baby Shower", value: "baby_shower" },
    { label: "Birthday Party", value: "birthday_party" },
  ];

  return (
    <Body className="w-full h-full" bannerLabel="Gallery" type="secondary">
      <TabBar
        className="mb-6 text-oldSilver"
        tabs={tabs}
        activeTab={selectedTab}
        onTabChange={(value) => setSelectedTab(value)}
      />
      <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4 w-full mb-6">
        {selectedTab === "outdoor" ? (
          <>
            <Player url="https://www.youtube.com/shorts/Tr3xBLcTJF8" />
          </>
        ) : selectedTab === "baby_shower" ? (
          <>
            <Player url="https://www.youtube.com/shorts/2_2v79Wp__Q" />
            <Player url="https://www.youtube.com/shorts/t6J5-MBkXNY" />
            <Player url="https://www.youtube.com/watch?v=u23geLEdf7A" />
          </>
        ) : selectedTab === "birthday_party" ? (
          <>
            <Player url="https://www.youtube.com/watch?v=8yTxjRq4NYI" />
            <Player url="https://www.youtube.com/watch?v=tSmhLqkoSi8" />
          </>
        ) : (
          <>
            <Player url="https://www.facebook.com/facebook/videos/10153231379946729/" />
            <Player url="https://www.facebook.com/facebook/videos/10153231379946729/" />
          </>
        )}
      </div>
    </Body>
  );
};

export default React.memo(Video);
